import React from 'react';
import { SectionSubtitle, SectionTitle } from '../SectionText';
import { useLocale } from 'locale';
import styled from '@emotion/styled';
import { ParameterItem } from './ParameterItem';
import HandShake from '../../images/handshake.svg';
import Clipboard from '../../images/clipboard.svg';
import PieChart from '../../images/piechart.svg';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(2)};

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    gap: ${theme.spacing(6)};
  `}
`;

const ItemsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: ${({ theme }) => theme.spacing(5)};

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    max-width: 776px;
    width: 100%;
    flex-direction: row;
    justify-content: space-between;
  `}
`;

const Title = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: ${({ theme }) => theme.spacing(1)};

  ${({ theme }) => theme.media.showAt({ from: 2 })`
    gap: ${theme.spacing(1.5)};
  `}
`;

export const ParametersSection: React.FC = () => {
  const { t } = useLocale();

  return (
    <Wrapper>
      <Title>
        <SectionTitle weight="bold">
          {t('madad.2026.parameters.title')}
        </SectionTitle>
        <SectionSubtitle>
          {t('madad.2026.parameters.subtitle')}
        </SectionSubtitle>
      </Title>
      <ItemsWrapper>
        <ParameterItem
          title={t('madad.2026.parameters1.title')}
          subtitle={t('madad.2026.parameters1.subtitle')}
          image={<HandShake />}
        />
        <ParameterItem
          title={t('madad.2026.parameters2.title')}
          subtitle={t('madad.2026.parameters2.subtitle')}
          image={<Clipboard />}
        />
        <ParameterItem
          title={t('madad.2026.parameters3.title')}
          subtitle={t('madad.2026.parameters3.subtitle')}
          image={<PieChart />}
        />
      </ItemsWrapper>
    </Wrapper>
  );
};
